export enum TransactionAdjustmentType {
  TOTAL = "TOTAL",
  PARTIAL = "PARTIAL"
}